const initialState = true;

const calendarMaxViewReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'TOGGLE_CALENDAR_MAX_VIEW':
            return !state;
        default:
            return state;
    }
};

export default calendarMaxViewReducer;
